import {AuthAPI} from './WebAPI.js'; 
import AuthenticationStore from './AuthenticationStore.js'; 


const AuthenticationAPI = {
		init(){
			return AuthAPI.performAuthentication();
		}
};
export default AuthenticationAPI;